import React from "react";
import * as Styled from "./styles";
import {
  TextField,
  Button,
} from "@mui/material";
import { useClinicalEvaluation } from "shared/providers/ClinicalEvaluation";

const ClinicalEvaluationScreen: React.FC = () => {
  const {
    complaint,
    setComplaint,
    complaintError,
    setComplaintError,
    treatmentEvolution,
    setTreatmentEvolution,
    treatmentEvolutionError,
    setTreatmentEvolutionError,
    patientObj,
    setStep,
  } = useClinicalEvaluation();

  const hasActiveOrto = !!patientObj?.budget;

  const handleContinue = () => {
    let valid = true;

    if (complaint.length < 20) {
      setComplaintError("A queixa principal deve conter pelo menos 20 caracteres.");
      valid = false;
    } else {
      setComplaintError("");
    }

    if (hasActiveOrto) {
      if (treatmentEvolution.length < 20) {
        setTreatmentEvolutionError("A evolução do tratamento deve conter pelo menos 20 caracteres.");
        valid = false;
      } else {
        setTreatmentEvolutionError("");
      }
    }

    if (valid) {
      setStep(2);
    }
  };

  return (
    <Styled.Box>
      <Styled.BoxDescription>
        <h5>Queixa Principal</h5>
        <TextField
          minRows={3}
          maxRows={5}
          multiline
          value={complaint}
          onChange={(e) => {
            setComplaint(e.target.value);
            if (e.target.value.length >= 20) {
              setComplaintError("");
            }
          }}
          error={!!complaintError}
          helperText={complaintError}
          placeholder="Descreva a queixa principal do paciente nesta avaliação..."
        />
      </Styled.BoxDescription>

      {hasActiveOrto && (
        <Styled.BoxDescription>
          <h5>Evolução do Tratamento</h5>
          <TextField
            minRows={3}
            maxRows={5}
            multiline
            value={treatmentEvolution}
            onChange={(e) => {
              setTreatmentEvolution(e.target.value);
              if (e.target.value.length >= 20) {
                setTreatmentEvolutionError("");
              }
            }}
            error={!!treatmentEvolutionError}
            helperText={treatmentEvolutionError}
            placeholder="Descreva a evolução do tratamento ortodôntico desde a última avaliação..."
          />
        </Styled.BoxDescription>
      )}

      <Styled.BtnFixed>
        <Button fullWidth onClick={handleContinue} variant="contained">
          Continuar
        </Button>
      </Styled.BtnFixed>
    </Styled.Box>
  );
};

export { ClinicalEvaluationScreen };
